import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutStats from './components/AboutStats';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import BlogSection from './components/BlogSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutStats />
        <TestimonialSection />
        <CTASection />
        <BlogSection />
      </main>
      <Footer />
    </>
  );
}